













import { Component, Vue } from 'vue-property-decorator'
import Menu from '@/components/Profil/Menu.vue'

@Component({
    components: {
        Menu,
    },
})
export default class IndexProfil extends Vue {}
